export default __webpack_public_path__ + "static/media/cdot_logo_full.65821859.png";